import { memo, type MouseEvent as ReactMouseEvent } from 'react';
import { Center } from '~/commonComponents/Center';
import { Column } from '~/commonComponents/Column';
import { Value as FieldValue } from '~/commonComponents/InputJob/Field';
import { Row } from '~/commonComponents/Row';
import { Text } from '~/commonComponents/Text';
import { CloseIcon } from '~/images/icons';
import PlusIcon from '~/images/icons/PlusIcon';
import { Colors } from '~/themes/colors';
import { IInputInviteCandidateValue } from './Types';

interface IValueProps {
  values?: IInputInviteCandidateValue[];
  onInviteMoreClick?(): void;
  onRemoveProfessional?(value: IInputInviteCandidateValue, index: number): void;
}

const Component = ({ values = [], onInviteMoreClick, onRemoveProfessional }: IValueProps) => {
  const hasValues = values.length > 0;

  const handleInviteMoreClick = (e: ReactMouseEvent) => {
    e.stopPropagation();
    onInviteMoreClick?.();
  };

  const handleRemoveProfessionalClick = (index: number) => (e: ReactMouseEvent) => {
    e.stopPropagation();
    onRemoveProfessional?.(values[index], index);
  };

  if (!hasValues) {
    return <FieldValue style={{ color: Colors.neutral_300 }} text="Add Candidates" />;
  }

  return (
    <Column alignItems="flex-end" gap={15}>
      {values.map((it, i) => (
        <Row data-testid={`input-invite-candidate.item-${it.value}`} key={it.value}>
          <Text
            data-testid={`input-invite-candidate.item-${it.value}.text`}
            textTransform="capitalize"
          >
            {it.label}
          </Text>
          <Center
            data-testid={`input-invite-candidate.item-${it.value}.close-icon`}
            cursor="pointer"
            marginLeft={30}
            marginRight={-30}
            role="button"
            onClick={handleRemoveProfessionalClick(i)}
          >
            <CloseIcon color={Colors.secondary_500} />
          </Center>
        </Row>
      ))}

      <Row
        alignItems="center"
        cursor="pointer"
        data-testid={`input-invite-candidate.add-invite-more`}
        gap={8}
        role="button"
        onClick={handleInviteMoreClick}
      >
        <PlusIcon color={Colors.secondary_500} />
        <Text bold color={Colors.secondary_500} fontSize={18}>
          Invite More
        </Text>
      </Row>
    </Column>
  );
};

export const Value = memo(Component);
